import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_SCHOLAR_REGISTER_TIME = gql`
  query RookieDayScholarRegisterTime($districtId: Int!) {
    rookiedayScholarRegisterTime(districtId: $districtId) {
      openAt
      closeAt
    }
  }
`;
